module.exports = __webpack_public_path__ + "static/img/adImg.360dced.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/adImg.png
// module id = 2OIO
// module chunks = 2